/**
 @since: 2020-04-06
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'

const getCeilName = (item) => {
  return item.qos_prf_ceil.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export const state = () => ({
  url: '/api/po/qos/profiles',
  applyUrl: '/api/po/command/qos-profiles',
  qosProfile: {
    qos_prf_id: 1, // (integer)(not null) QoS 프로파일 ID
    qos_prf_type: 1, // (integer)(Define=1,5) 1: 방화벽, 5: vlan
    qos_prf_ceil: 100000000, // (integer)(not null)(range=1000-100000000) 송신 제한 대역폭 Kbps
    qos_prf_name: '', // (string)(not null)(range=1-32) 프로파일 이름
    qos_prf_desc: '', // "(string)(max=128) 프로파일 설명",
    qos_prf_auto_rate: 1, // "(integer)(Define=1,2) QoS 프로파일 제한 제한 전용 사용:2, 제한 전용 미사용:1
    cfg_adm_id: 1,
    admin_login_uname: '',
    cfg_dt: '',
    qos_ifc_ref: null //  "(integer) 인터페이스 정책 사용여부 사용안함 : 0, 사용: 1"
  },
  rowSelectItems: [],
  selPolicySelectedProfile: '',
  qosProfileList: [],
  qosProfileInterfaces: []
})

export const mutations = {
  initQoSProfile (state) {
    state.qosProfileList = []
    state.qosProfileInterfaces = []
    state.rowSelectItems = []
    state.selPolicySelectedProfile = ''
    state.selQueue = {}
  },
  getQoSProfileList (state, data) {
    state.qosProfileList = Object.freeze(_.map(data, (item) => {
      item.qos_prf_ceil = getCeilName(item)
      return item
    }))
  },
  getQoSProfileInterfaces (state, data) {
    state.qosProfileInterfaces = Object.freeze(data)
  },
  getQoSProfile (state, data) {
    state.qosProfile = _.cloneDeep(data)
  },
  addQoSProfile (state, data) {
    const cloneQoSProfileList = _.cloneDeep(state.qosProfileList)
    data.qos_prf_ceil = getCeilName(data)
    cloneQoSProfileList.push(data)
    state.qosProfileList = Object.freeze(cloneQoSProfileList)
  },
  editQoSProfile (state, data) {
    state.qosProfileList = Object.freeze(_.map(state.qosProfileList, (o) => {
      if (o.qos_prf_id === data.qos_prf_id) {
        o.qos_prf_auto_rate = data.qos_prf_auto_rate
        o.qos_prf_ceil = getCeilName(data)
        o.qos_prf_desc = data.qos_prf_desc
        o.qos_prf_name = data.qos_prf_name
        o.qos_prf_type = data.qos_prf_type
      }
      return o
    }))
  },
  setRowSelectItems (state, data) {
    state.rowSelectItems = _.cloneDeep(data)
  }
}

export const actions = {
  // 프로파일 목록 조회
  async getQoSProfileList ({commit, state}, {loadingShow = true, loadingHide = true}) {
    try {
      const data = await this.$axios.$get(state.url, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSProfileList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 프로파일 사용 컬럼 팝업 데이터
  async getQoSProfileInterfaces ({commit, state}, {pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${pk}/interfaces`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSProfileInterfaces', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 편집창 팝업시, 프로파일 개별 목록 조회
  async getQoSProfile ({commit, state}, {pk, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${pk}`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSProfile', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // QoS 프로파일 설정 추가
  async addQoSProfile ({ commit, state }) {
    const payload = {
      qos_prf_type: state.qosProfile.qos_prf_type,
      qos_prf_ceil: state.qosProfile.qos_prf_ceil,
      qos_prf_name: state.qosProfile.qos_prf_name,
      qos_prf_desc: state.qosProfile.qos_prf_desc,
      qos_prf_auto_rate: state.qosProfile.qos_prf_auto_rate
    }
    try {
      const data = await this.$axios.$post(state.url, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addQoSProfile', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 프로파일 편집
  async editQoSProfile ({ commit, state }, {pk}) {
    const uri = `${state.url}/${pk}`
    const payload = {
      qos_prf_type: state.qosProfile.qos_prf_type,
      qos_prf_ceil: state.qosProfile.qos_prf_ceil,
      qos_prf_name: state.qosProfile.qos_prf_name,
      qos_prf_desc: state.qosProfile.qos_prf_desc,
      qos_prf_auto_rate: state.qosProfile.qos_prf_auto_rate
    }
    try {
      const data = await this.$axios.$put(uri, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editQoSProfile', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 프로파일 삭제
  async delQoSProfile ({ commit, state }) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({qos_prf_id: item.qos_prf_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.url}`, {data: {items: idList}})
        : await this.$axios.$delete(`${state.url}/${state.rowSelectItems[0].qos_prf_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.applyUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
